"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = defaultImport;
function defaultImport(module) {
    if (module.__esModule && module.default) {
        return module.default;
    } else {
        return module;
    }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvdXRpbHMvZGVmYXVsdEltcG9ydC5qc3giXSwibmFtZXMiOlsiZGVmYXVsdEltcG9ydCIsIm1vZHVsZSIsIl9fZXNNb2R1bGUiLCJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7OztrQkFBd0JBLGE7QUFBVCxTQUFTQSxhQUFULENBQXVCQyxNQUF2QixFQUErQjtBQUMxQyxRQUFJQSxPQUFPQyxVQUFQLElBQXFCRCxPQUFPRSxPQUFoQyxFQUF5QztBQUNyQyxlQUFPRixPQUFPRSxPQUFkO0FBQ0gsS0FGRCxNQUVPO0FBQ0gsZUFBT0YsTUFBUDtBQUNIO0FBQ0oiLCJmaWxlIjoiZGVmYXVsdEltcG9ydC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGRlZmF1bHRJbXBvcnQobW9kdWxlKSB7XG4gICAgaWYgKG1vZHVsZS5fX2VzTW9kdWxlICYmIG1vZHVsZS5kZWZhdWx0KSB7XG4gICAgICAgIHJldHVybiBtb2R1bGUuZGVmYXVsdFxuICAgIH0gZWxzZSB7XG4gICAgICAgIHJldHVybiBtb2R1bGVcbiAgICB9XG59XG4iXX0=